import { autoRegisterFeature } from '@store/features/factory';

import { jotSupportFeature } from './store/feature';

autoRegisterFeature(jotSupportFeature);

export { JotSupportContainer } from './components/JotSupportContainer';
export { useCheckSupportRequest, useSubmitSupportRequest } from './store';
